export type { FieldWrapperProps } from './FieldWrapper/FieldWrapper.types'
export { FieldWrapper } from './FieldWrapper'

export type { TextInputFieldProps } from './TextInputField/TextInputField.types'
export { TextInputField } from './TextInputField'

export type { TextareaFieldProps } from './TextareaField/TextareaField.types'
export { TextareaField } from './TextareaField'

export type { NumberInputFieldProps } from './NumberInputField/NumberInputField.types'
export { NumberInputField } from './NumberInputField'

export type { DateInputFieldProps } from './DateTimeInputField/DateTimeInputField.types'
export { DateTimeInputField, DateInputField, MonthInputField } from './DateTimeInputField'

export type { RadioInputFieldProps } from './RadioInputField/RadioInputField.types'
export { RadioInputField } from './RadioInputField'

export type { SingleSelectFieldProps, MultiSelectFieldProps } from './SelectField/SelectField.types'
export { SingleSelectField, MultiSelectField } from './SelectField'

export type { AddressWithPostalCodeFieldProps } from './AddressWithPostalCodeField/AddressWithPostalCodeField.types'
export { AddressWithPostalCodeField } from './AddressWithPostalCodeField'

export type { NameInputFieldProps } from './NameInputField/NameInputField.types'
export { NameInputField } from './NameInputField'

export type { FiveStageInputFieldProps } from './FiveStageInputField/FiveStageInputField.types'
export { FiveStageInputField } from './FiveStageInputField'

export type { CheckboxGroupFieldProps } from './CheckboxGroupField/CheckboxGroupField.types'
export { CheckboxGroupField } from './CheckboxGroupField'

export const validationRules = {
  required: (label?: string) => `${label ? `${label}を` : ''}入力してください`,
  requiredSelect: (label?: string) => `${label ? `${label}を` : ''}選択してください`,
  requiredCreatableSelect: (label?: string) => `${label ? `${label}を` : ''}選択/入力してください`,
  pattern: {
    email: (label?: string) => ({
      value: /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/,
      message: `${label ? `${label}は` : ''}メールアドレスの形式で入力してください`,
    }),
    phoneNumber: (label?: string) => ({
      value: /^0\d{1,3}-\d{2,4}-\d{3,4}$/,
      message: `${label ? `${label}は` : '電話番号は'}ハイフン付きで入力してください。`,
    }),
    postalCode: (label?: string) => ({
      value: /^[0-9]{3}-[0-9]{4}$/,
      message: `${label ? `${label}は` : '郵便番号は'}ハイフン付き(3桁-4桁)で入力してください。`,
    }),
    hiragana: (label?: string) => ({
      value: new RegExp('^[ぁ-ん][ぁ-んー]*([ |　][ぁ-んー]+)*$'),
      message: `${label ? `${label}は` : ''}ひらがなで入力してください`,
    }),
    katakana: (label?: string) => ({
      value: new RegExp('^[ァ-ン][ァ-ンー]*([ |　][ァ-ンー]+)*$'),
      message: `${label ? `${label}は` : ''}カタカナで入力してください`,
    }),
    hiraganaOrKatakana: (label?: string) => ({
      value: new RegExp('^[ぁ-んァ-ン][ぁ-んァ-ンー]*([ |　][ぁ-んァ-ンー]+)*$'),
      message: `${label ? `${label}は` : ''}ひらがな/カタカナで入力してください`,
    }),
  },
  min: (value: number) => ({
    value,
    message: `${value}以上で入力してください`,
  }),
  max: (value: number) => ({
    value,
    message: `${value}以下で入力してください`,
  }),
  minLength: (value: number) => ({
    value,
    message: `${value}文字以上で入力してください`,
  }),
  maxLength: (value: number) => ({
    value,
    message: `${value}文字以下で入力してください`,
  }),
  isSame: (value: string, targetValue: string, label?: string) => {
    return (value === targetValue) || `${label ? label : 'メールアドレス'}が一致しません`
  },
  isDifference: (value: string, targetValue: string, label?: string) => {
    return (!value || value !== targetValue) || `${label ? label : 'メールアドレス'}は違う値を入力してください`
  }
}
